import { fetchGet, fetchPost } from '~shared/util/fetchUtil'
import { getAuthToken, getRequestAuthOptions } from '~shared/util/authUtil'
import GlobalStore from '../Stores/GlobalStore'
import type { IItemOption } from '~shared/lib/ItemDetail/Types'
import type { ItemAvailability } from '../Types/ItemAvailability'

export async function fetchItemOptionsForSiteId(
  itemId: string,
  siteId?: string | null
): Promise<IItemOption[]> {
  const url = siteId
    ? `${GlobalStore.apiUrl}/oms/items/${itemId}/orderoptions?siteId=${siteId}`
    : `${GlobalStore.apiUrl}/oms/items/${itemId}/orderoptions`

  const data = await fetchGet<IItemOption[]>(url, { token: getAuthToken() })
  return Array.isArray(data) ? data : []
}

export async function fetchCatalogItems(
  siteId: string,
  departmentId: string
): Promise<ItemAvailability[]> {
  const url = `${GlobalStore.apiUrl}/oms/sites/${siteId}/departments/${departmentId}/items`
  return fetchGet<ItemAvailability[]>(url, { token: getAuthToken() })
}

export async function setItemAvailability(
  siteId: string,
  itemId: string,
  available: boolean,
  stepUpToken?: string
): Promise<void> {
  await fetchPost<unknown>(
    `${GlobalStore.apiUrl}/sites/${siteId}/items/${itemId}/availability`,
    { Available: available },
    getRequestAuthOptions(stepUpToken)
  )
}

export async function setItemOptionAvailability(
  siteId: string,
  itemId: string,
  itemOptionId: string,
  available: boolean,
  stepUpToken?: string
): Promise<void> {
  await fetchPost<unknown>(
    `${GlobalStore.apiUrl}/sites/${siteId}/items/${itemId}/itemOptions/${itemOptionId}/availability`,
    { Available: available },
    getRequestAuthOptions(stepUpToken)
  )
}

export async function setItemOptionItemAvailability(
  siteId: string,
  itemId: string,
  itemOptionItemId: string,
  available: boolean,
  stepUpToken?: string
): Promise<void> {
  await fetchPost<unknown>(
    `${GlobalStore.apiUrl}/sites/${siteId}/items/${itemId}/itemOptionItems/${itemOptionItemId}/availability`,
    { Available: available },
    getRequestAuthOptions(stepUpToken)
  )
}
